module.exports = __webpack_public_path__ + "static/media/05.c1a3940a.jpg";